<template>
  <div class="sub_detail">
    <y-header :active="'index'" />
    <!-- <el-image style="width: 96vw; height: 20vw;margin: 2vw 1vw" fit="cover" :src="mainColumn.cover" /> -->
    <div style="margin: 1vw 0;" />

    <!--    内容区域-->
    <el-row class="content-info">
      <div v-show="!isPC" class="menu-container">
        <!-- 按钮 -->
        <div class="toggle-button" @click="toggleMenu">
          <i :class="isMenuVisible ? 'el-icon-s-fold':'el-icon-s-unfold'" style="font-size: 6vw;color: #fff;" />
        </div>
        <!-- 菜单 -->
        <el-col v-if="isMenuVisible" :span="5" class="main-col">
          <!-- 主菜单 -->
          <div class="mainMenu">
            <span>{{ mainColumn?.name }}</span>
            <!--            <span>{{ $t(mainColumn?.code) }} </span>-->
          </div>
          <!-- 子菜单 -->
          <span
            v-for="(childItem,index) in subColumn"
            v-show="currentSegment==='xmsbzx'"
            :key="index"
            class="submenu"
            :class="{'submenu-hover': childItem.code==code}"
            @click="navigateToSubMenu(childItem)"
          >
            {{ childItem?.name }}
          </span>
          <nuxt-link
            v-for="(childItem,index) in subColumn"
            v-show="currentSegment!=='xmsbzx' && childItem.status!==2"
            :key="index"
            class="submenu"
            :class="{'submenu-hover': childItem.code==code}"
            :to="localePath({ name: 'submenu-id', params: { id: childItem.code } })"
          >
            {{ childItem?.name }}
            <!--            {{ $t(childItem?.code) }}-->
          </nuxt-link>
        </el-col>
      </div>

      <!--      菜单栏-->
      <el-col v-show="isPC" :span="5" class="main-col">
        <!--    主菜单-->
        <div class="mainMenu">
          {{ mainColumn?.name }}
          <!--          {{ $t(mainColumn?.code) }}-->
        </div>
        <!--    子菜单-->
        <span
          v-for="(childItem,index) in subColumn"
          v-show="currentSegment==='xmsbzx'"
          :key="index"
          class="submenu"
          :class="{'submenu-hover': childItem.code==code}"
          @click="navigateToSubMenu(childItem)"
        >
          {{ childItem?.name }}
        </span>
        <nuxt-link
          v-for="(childItem,index) in subColumn"
          v-show="currentSegment!=='xmsbzx' && childItem.status!==2"
          :key="index"
          class="submenu"
          :class="{'submenu-hover': childItem.code==code}"
          :to="localePath({ name: 'submenu-id', params: { id: childItem.code } })"
        >
          {{ childItem?.name }}
          <!--          {{ $t(childItem?.code) }}-->
        </nuxt-link>
      </el-col>
      <el-col :span="isPC? 19:24" style="padding-right: 2vw">
        <el-row
          style="border-bottom:1px dotted #CFCFCF;display: flex;flex-direction: row;justify-content: center;align-items: baseline;"
        >
          <el-col :span="12" align="left">
            <!--            <span style="font-weight: normal" class="left-mainName">{{ getCodeVal(code)?.name }}</span>-->
            <span style="font-weight: normal" class="left-mainName">{{ getCodeVal(code)?.name }}</span>
          </el-col>
          <el-col :span="12" align="right">
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              style="float:right; font-weight: normal"
              class="right-menu"
            >
              <el-breadcrumb-item :to="localePath({ path: '/' })">{{ $t("wzsy") }}</el-breadcrumb-item>
              <el-breadcrumb-item :to="localePath({ path: `/submenu/${code}` })">
                {{ mainColumn?.name }}</el-breadcrumb-item>
              <el-breadcrumb-item
                :to="localePath({ path: `/submenu/${code}` })"
              >{{ getCodeVal(code)?.name }}</el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
        </el-row>
        <div>
          <el-row :style="{ height: isPC ? '5vw' : '8vw' }">
            <el-col :span="24" align="center">
              <h4 :style="{ lineHeight: isPC ? '5vw' : '8vw',fontSize: isPC ? '1.5vw' : '3vw' }">{{ article?.title }}
              </h4>
              <!--              <h4 v-if="currentlocale=='enObj'" :style="{ lineHeight: isPC ? '5vw' : '8vw',fontSize: isPC ? '1.5vw' : '3vw' }">{{ article?.titleEn }}</h4>-->
            </el-col>
          </el-row>
          <el-row :style="{ borderBottom: isPC ? '1px dotted #CFCFCF' : '2px dotted #CFCFCF',paddingBottom: '2vw' }">
            <el-col :span="12" align="right">
              <span
                :style="{ marginRight: isPC ? '10px' : '20px',fontSize: isPC ? '1vw' : '2vw' }"
              >作者：{{ article?.author }}</span>
            </el-col>
            <el-col :span="12" align="left">
              <span
                :style="{ marginLeft: isPC ? '10px' : '20px',fontSize: isPC ? '1vw' : '2vw' }"
              >时间：{{ article?.time?.substring(0,10) }}</span>
            </el-col>
          </el-row>
          <el-row>
            <div
              ref="content"
              :style="{ padding: isPC ? '2vw' : '4vw' }"
              class="mobile-html content-style"
              v-html="article?.content"
            />
            <!--            <div v-if="currentlocale=='enObj'" ref="content" :style="{ padding: isPC ? '2vw' : '4vw' }" class="mobile-html" v-html="article?.contentEn" />-->
          </el-row>
          <!-- 附件下载 -->
          <el-row v-show="article?.filesList!==null && article?.filesList?.length!==0">
            <div :style="{ padding: isPC ? '2vw' : '4vw' }">
              <div v-show="article?.filesList!==null && article?.filesList?.length!==0" :style="{ fontWeight: 'bold', fontSize: '1.2em', marginBottom: isPC ? '1vw' : '2vw' }">附件：</div>
              <div
                v-for="(item, index) in article?.filesList"
                :key="index"
                :style="getItemStyle(index)"
                @mouseover="hoverIndex = index"
                @mouseleave="hoverIndex = null"
              >
                <div style="display: flex; align-items: center;">
                  <i
                    class="el-icon-document"
                    :style="{ color: '#333', fontSize: '1.4em', marginRight: isPC ? '0.5vw' : '1vw' }"
                  />
                  <span style="font-size: 1em; font-weight: 500; color: #333;">{{ item.name }}</span>
                </div>
                <div>
                  <i
                    class="el-icon-download"
                    style="font-size: 1.2em; color: #007bff; cursor: pointer;font-weight: bold;"
                    @click="downloadFile(item)"
                  />
                </div>
              </div>
            </div>

          </el-row>

        </div>
        <!-- 底部的翻页-->
        <div class="footer-page">
          <!--上一篇 -->
          <div v-if="prevNode" class="pre">
            上一篇：
            <nuxt-link :to="localePath(`/submenu/${code}/subarticle/${prevNode?.id}`)">
              {{ prevNode?.title }}
            </nuxt-link>
            <!-- <nuxt-link v-if="currentlocale=='enObj'" :to="localePath(`/submenu/${code}/subarticle/${prevNode?.id}`)">
              {{ prevNode?.titleEn }}
            </nuxt-link> -->
          </div>
          <!--下一篇 -->
          <div v-if="nextNode" class="next">
            下一篇：
            <nuxt-link :to="localePath(`/submenu/${code}/subarticle/${nextNode?.id}`)">
              {{ nextNode?.title }}
            </nuxt-link>
            <!--  <nuxt-link v-if="currentlocale=='enObj'" :to="localePath(`/submenu/${code}/subarticle/${nextNode?.id}`)">
              {{ nextNode?.titleEn }}
            </nuxt-link> -->
          </div>
        </div>
      </el-col>
    </el-row>
    <y-footer />
  </div>
</template>
<script>
import YHeader from '@/components/common/Header.vue'
import config from '@/config'
import {
  getArticleInfo,
  getArticles
} from '@/api/main'
import {
  download
} from '~/api/apply.js'
import YFooter from '@/components/common/Footer.vue'
import {
  getStore
} from '../../../../utils/storage'

export default {
  components: {
    YFooter,
    YHeader
  },
  async asyncData(context) {
    try {
      const result = {}
      console.log('context.route灌灌灌灌哈哈', context.params)
      console.log('context.route灌灌灌灌哈哈', context.store.state.itemcate)
      // 判断类型
      // const url = context.route.path
      // const parts = url.split('/')

      // 假设 hyfc 字段总是位于第二个位置（在 "/submenu" 之后）
      // const hyfcIndex = 2
      // let code = '' // if (parts.length > hyfcIndex) {
      //   const hyfcField = parts[hyfcIndex]
      //   code = hyfcField // 输出: hyfc
      // } else {
      //   console.log('URL 格式不正确或 hyfc 字段不存在')
      // }

      // //子菜单
      // 使用 filter 方法查找
      const code = context.params.id
      const articleId = context.params.subId
      const navlist = context.store.state.navList
      // console.log("navlist",navlist)
      // 根据id筛选的节点
      let node = null
      // 如果父id为空则为一级目录
      node = navlist.find(item => {
        return item.mainColumn.code === code
      })

      if (node == undefined) {
        for (const nodeKey in navlist) {
          const childNode = navlist[nodeKey].subColumn
          console.log('childNode', childNode)
          if (childNode) {
            let child = childNode.filter(childItem => childItem.code === code)
            if (child && child.length > 0) {
              node = navlist[nodeKey]
              break
            } else { // 如果子级没有
              console.log('enter', child)
              child = childNode.filter(childItem => {
                return childItem.childrens && childItem.childrens.filter(subChild => {
                  return subChild.code === code
                })
              })
            }
            console.log('child', child)
            if (Array.isArray(child) && child.length > 0) {
              node = navlist[nodeKey]
            }
          }
        }
      }

      if (node.mainColumn) {
        result.mainColumn = node.mainColumn
      }
      if (node.subColumn) {
        result.subColumn = node.subColumn
      }
      console.log('data', node)

      // 是文章才展示文章页面  是栏目则展示文章列表
      const article = await getArticleInfo(context.store.state.itemcate[code], articleId)
      const articlesList = await getArticles(context.store.state.itemcate[code])
      result.article = article
      result.articlesList = articlesList
      result.code = code
      console.log('result===>', result)
      return result
    } catch (e) {
      context.error({
        message: 'Data not found',
        statusCode: 404
      })
    }
  },
  data() {
    return {
      // 测试文件下载
      hoverIndex: null, // 跟踪当前悬停的项的索引

      // fileList: [{
      //   name: 'food.jpeg',
      //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      // }, {
      //   name: 'food.jpeg',
      //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      // }],
      tab: 'info',
      mainItem: null,
      subItem: null,
      navList: this.$store.state.navList,
      isHovered: false,
      // 上一篇文章的节点
      prevNode: null,
      // 下一篇文章的节点
      nextNode: null,
      isMenuVisible: false, // 控制菜单的显示状态
      currentlocale: 'zhObj',
      isPC: false,
      code: 'cpfb'
    }
  },
  head() {
    return {
      title: this.$store.state.websiteInfo.name
    }
  },
  computed: {
    currentSegment() {
      const match = this.$route.path.match(/\/submenu\/(.*?)\/subarticle/) // 使用正则表达式匹配
      return match ? match[1] : null // 返回匹配的部分
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
  },

  mounted() {
    this.checkDevice()
    this.getLocale()
    window.addEventListener('resize', this.checkDevice)
    this.getPrevAndNext(this.article, this.articlesList)
  },
  methods: {
    // 动态获取每个附件项的样式
    getItemStyle(index) {
      return {
        width: this.isPC ? '40%' : '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: this.isPC ? '1vw' : '2vw',
        padding: this.isPC ? '1vw' : '2vw',
        borderRadius: '8px',
        backgroundColor: this.hoverIndex === index ? '#f0f0f0' : '#f9f9f9',
        boxShadow: this.hoverIndex === index ? '0 2px 8px rgba(0, 0, 0, 0.1)' : '0 2px 8px rgba(0, 0, 0, 0.05)',
        transform: this.hoverIndex === index ? 'scale(1.02)' : 'scale(1)',
        transition: 'all 0.3s ease'
      }
    },

    navigateToSubMenu(childItem) {
      if (this.$store.state.tokenInfo || childItem?.code === 'xmsbzx') {
        this.$router.push(this.localePath({
          name: 'submenu-id',
          params: {
            id: childItem.code
          }
        }))
      } else {
        this.$message.warning('该栏目需要注册成为陕西省服务贸易和数字贸易协会会员后才能访问。请点击网站右上角完成注册。')
      }
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible // 切换菜单显示状态
    },
    getLocale() {
      this.currentlocale = getStore('currentLocale')
    },
    checkDevice() {
      if (typeof window !== 'undefined') {
        this.isPC = window.innerWidth > 768 // 根据需要调整阈值
      }
      console.log('当前设备', this.isPC)
    },
    // 处理文章上一篇和下一篇
    getPrevAndNext(article, articlesList) {
      console.log('上下片++++++++++++++', articlesList)
      this.prevNode = null
      this.nextNode = null
      if (articlesList.length > 0) {
        for (const [index, item] of articlesList.entries()) {
          if (item.id === article.id) {
            if (index > 0) {
              this.prevNode = articlesList[index - 1]
            }
            if (index < articlesList.length - 1) {
              this.nextNode = articlesList[index + 1]
            }
            break
          }
        }
      }
    },

    // 获取code对应的节点
    getCodeVal(code) {
      // 从submenu中获取code对应的节点
      const child = this.subColumn.find(item => item.code === code)
      return child
    },

    /**
       * 导出数据
       */
    downloadFile(file) {
      // 会员类型
      let fileObj = {}
      fileObj = this.getFile(file)
      console.log('fileObj-----', fileObj)
      const {
        actulFileName,
        fileName
      } = fileObj
      console.log('fileObj', fileObj)
      console.log('下载文件文件名', actulFileName)
      if (fileName) {
        // 下载文件
        download(actulFileName)
          .then((res) => {
            console.log('res', res)
            this.downloadExcel(res, fileName)
          })
          .catch((e) => {
            console.log(e)
            this.$message.error(this.$t('checkText.downloadFail'))
          })
      }
    },
    getFile(file) {
      if (file) {
        let actulFileName = ''
        const {
          name: fileName, // 提取 name 字段作为 fileName
          url: fileUrl // 提取 url 字段作为 fileUrl
        } = file
        // 如果 fileName 和 fileUrl 都存在
        if (fileName && fileUrl) {
          // 假设 baseUrl 需要从 fileUrl 中去掉的一部分
          actulFileName = fileUrl.replace(config.baseUrl, '') // 去掉 baseUrl 部分
        }
        // 返回包含 actulFileName 和 fileName 的对象
        return {
          actulFileName: actulFileName,
          fileName: fileName
        }
      } else {
        // 如果 file 不存在，返回空的默认对象
        return {
          actulFileName: '',
          fileName: ''
        }
      }
    },

    /**
       * 读取指定blob,返回转换为base64后的结果
       * @param blob
       * @returns {Promise<unknown>}
       */
    downloadExcel(response, fileName) {
      const blob = new Blob([response])
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = fileName
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }

  }
}
</script>
<style lang="scss" scoped>
  @media (max-width: 768px) {
    // .foot {
    //   position: fixed;
    //   bottom: 0;
    //   left: 0;
    //   right: 0;

    // }

    .mobile-html {
      width: 100% !important;
      margin: auto;

      ::v-deep video {
        width: 80vw !important;
        height: auto;
      }

      ::v-deep img {
        width: 80vw !important;
        height: auto;
        object-fit: contain;
      }

    }

    .footer-page {
      font-size: 2vw !important;

      margin-bottom: 10vw !important;

      .pre,
      .next {
        margin: 0 4vw !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .detail-info {
      .font {
        margin-left: 4vw !important;
        font-size: 1.6vw !important;

        padding: 4px !important;
        bordr-radius: 4px !important;
      }
    }

    .ellipsis {
      margin-left: 4vw !important;
      margin-bottom: 2vw !important;
      font-size: 2vw !important;
      /* 设置文本大小 */
    }

    .left-mainName {
      font-size: 3vw !important;
    }

    .right-menu {
      font-size: 2vw !important;
    }

    // .foot {
    //   position: fixed;
    //   bottom: 0;
    //   left: 0;
    //   right: 0;

    // }

    .sub_detail {
      height: auto;
    }

    .content-info {
      min-height: auto !important;
      padding-bottom: 10vh;
      padding-left: 3vw;
      padding-right: 3vw;
    }

    .menu-container {
      position: relative;
      /* 使得菜单相对于此容器定位 */
    }

    .toggle-button {
      // border-radius: 80%;
      background: rgba(0, 0, 0, 0.5);
      padding: 2vw;
      position: fixed;
      top: 70px;
      /* 根据需要调整位置 */
      left: 0px;
      /* 根据需要调整位置 */
      z-index: 10;
      /* 确保按钮在最上层 */
      /* 根据需要自定义按钮样式 */
    }

    .main-col {
      width: auto;
      position: fixed;
      /* 菜单定位到页面上层 */
      top: 120px;
      /* 根据需要调整位置 */
      left: 0;
      /* 根据需要调整位置 */
      background-color: white;
      /* 菜单背景色，可根据需要调整 */
      border: 1px solid #ddd;
      /* 边框样式 */
      padding: 10px;
      /* 内边距 */
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      /* 阴影效果 */
      z-index: 10;
    }

    .mainMenu {
      font-size: 3vw !important;
      width: 36vw !important;
      height: 16vw !important;
      line-height: 9vw !important;
      text-align: center;
    }

    .submenu {
      line-height: 7vw !important;
      width: 36vw !important;
      height: 8vw !important;
      margin: 0.4vw 0 !important;
      font-size: 2vw !important;
      margin: 0.4vw 0 !important;
    }

  }

  .content-style {
    line-height: 2;        /* 设置行间距 */
    letter-spacing: 0.1em;    /* 设置字间距 */
  }

  .main-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
      color: white !important;
    }
  }

  .mainMenu {
    background-color: #009173;
    text-align: center;
    line-height: 7vw;
    width: 18vw;
    height: 7vw;
    color: white;
    font-size: 1.5vw;
    font-weight: bold;
    transition: background-color 0.3s ease;

    /* 添加过渡效果（可选） */
    a {
      color: white !important;
    }
  }

  //.mainMenu:hover {
  //  background-color: red; /* hover 时的背景颜色 */
  //}

  .submenu {
    text-align: center;
    line-height: 4vw;
    width: 18vw;
    height: 4vw;
    margin: 0.2vw 0;
    background-color: gray;
    color: white;
    font-size: 1vw;
    font-weight: bold;
    margin: 0.2vw 0;
    transition: background-color 0.3s ease;
    /* 添加过渡效果（可选） */
  }

  .submenu:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    background-color: #009173;
    /* hover 时的背景颜色 */
  }

  .submenu-hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    background-color: #009173;
    /* hover 时的背景颜色 */
  }

  .ellipsis {
    display: inline-block;
    /* 确保宽度属性生效 */
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏超出容器的内容 */
    text-overflow: ellipsis;
    /* 超出部分显示省略号 */
    //line-height: 25px; /* 设置行高 */
    color: #A19F9F;
    /* 设置文本颜色 */
  }

  .content-info {
    min-height: 50vh;
  }

  .footer-page {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5vw;

    .pre,
    .next {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 2vw;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  //.sub_detail {
  //  .detail_info {
  //    margin: 20px auto 60px;
  //    width: 1200px;
  //  }
  //
  //  .layout_left {
  //    width: 920px;
  //    float: left;
  //
  //    .info_body {
  //      margin-bottom: 30px;
  //    }
  //  }
  //
  //  .course_tab {
  //    padding-left: 30px;
  //    background: #fff;
  //    border-radius: 8px;
  //    margin-bottom: 20px;
  //
  //    li {
  //      float: left;
  //      height: 66px;
  //      line-height: 66px;
  //      margin-right: 80px;
  //
  //      &.on {
  //        border-bottom: 2px solid #D51423;
  //
  //        a {
  //          color: #D51423;
  //        }
  //      }
  //
  //      a {
  //        color: #000;
  //        font-size: 14px;
  //        font-weight: 700;
  //
  //        &:hover {
  //          text-decoration: none;
  //          color: #D51423;
  //        }
  //      }
  //    }
  //  }
  //
  //  .content_info {
  //    padding: 30px;
  //    background: #fff;
  //    border-radius: 8px;
  //    min-height: 400px;
  //
  //    .title {
  //      border-left: 3px solid #000;
  //      padding-left: 12px;
  //      font-size: 16px;
  //      color: #000;
  //      font-weight: 700;
  //      margin-bottom: 25px;
  //    }
  //
  //    .introduce {
  //      font-size: 14px;
  //      line-height: 30px;
  //      color: #333;
  //      padding-left: 8px;
  //    }
  //  }
  //
  //  .layout_right {
  //    width: 260px;
  //    float: right;
  //  }
  //
  //  .teacher_info {
  //    background: #fff;
  //    border-radius: 8px;
  //    position: relative;
  //    min-height: 180px;
  //
  //    .head {
  //      display: block;
  //      line-height: 60px;
  //      height: 60px;
  //      padding-left: 20px;
  //      font-size: 14px;
  //      color: #333;
  //      border-bottom: 1px solid rgb(228, 228, 228);
  //    }
  //
  //    .teacher_phone {
  //      width: 50px;
  //      height: 50px;
  //      border-radius: 50%;
  //      background: rgb(228, 228, 228);
  //      text-align: center;
  //      line-height: 46px;
  //      font-size: 13px;
  //      color: #999;
  //      float: left;
  //      margin: 0px 10px 0 10px;
  //
  //      img {
  //        width: 46px;
  //        height: 46px;
  //        border-radius: 50%;
  //      }
  //    }
  //
  //    .teacher_msg_right {
  //      width: 235px;
  //      float: right;
  //      margin: 12px 15px 12px 12px;
  //      line-height: 20px;
  //    }
  //
  //    .teacher_name {
  //      font-size: 18px;
  //      font-weight: 700;
  //      color: #333;
  //      margin: 5px 0;
  //    }
  //
  //    .teacher_position {
  //      font-size: 12px;
  //      color: #333;
  //      margin-bottom: 5px;
  //    }
  //  }
  //}

  //.submenu:hover {
  //  background-color: darkred; /* 悬停时的背景颜色 */
  //  color: #333; /* 悬停时的文字颜色 */
  //}
  //.submenu a{
  //  &:hover {
  //    background-color: #c91e1e;
  //  }
  //}
</style>
